/* eslint-disable */
import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Check, X, MapPin, Clock, ScanFace, CalendarDays, ClipboardCheck, Hourglass,
} from 'lucide-react';

export const TYPE_META = {
  address: { Icon: MapPin, color: '#4469A1', verb: 'requested an ', noun: 'address change' },
  working_hours: { Icon: Clock, color: '#5A81BC', verb: 'requested a ', noun: 'working hours update' },
  face_id: { Icon: ScanFace, color: '#315285', verb: 'requested ', noun: 'Face ID re-registration' },
  pto: { Icon: CalendarDays, color: '#378A35', verb: 'requested ', noun: 'time off' },
  ack: { Icon: ClipboardCheck, color: '#4683B4', verb: 'submitted an ', noun: 'acknowledgement' },
};

function initialsOf(name) {
  return (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join('')
    .toUpperCase() || '?';
}

function Message({ item }) {
  const meta = TYPE_META[item.type] || {};
  const parts = item.title || [{ b: item.actorName }, ' ', meta.verb, { b: meta.noun }, '.'];
  return (
    <div className="shoot-notif-msg">
      {parts.map((p, i) => (p && p.b
        ? <strong key={i}>{p.b}</strong>
        : <React.Fragment key={i}>{p}</React.Fragment>))}
    </div>
  );
}

function Detail({ item }) {
  const chips = [];
  if (item.type === 'pto' && item.dateRange) {
    chips.push(
      <span className="shoot-notif-detail" key="pto" style={{ marginTop: 0 }}>
        <span className="to">{item.dateRange}</span>
        {item.policy ? <><span className="arrow">·</span><span>{item.policy}</span></> : null}
        {item.duration ? <><span className="arrow">·</span><span>{item.duration}</span></> : null}
      </span>,
    );
  } else if (item.before || item.after) {
    chips.push(
      <span className="shoot-notif-detail" key="ba" style={{ marginTop: 0 }}>
        {item.before ? <><span>{item.before}</span><span className="arrow">→</span></> : null}
        <span className="to">{item.after}</span>
      </span>,
    );
  }
  if (item.note) {
    chips.push(
      <span className="shoot-notif-detail" key="note" style={{ marginTop: 0 }}><span>{item.note}</span></span>,
    );
  }
  if (!chips.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6, marginTop: 6 }}>
      {chips}
    </div>
  );
}

export default function NotificationRow({
  item, busy, onApprove, onReject, onOpen,
}) {
  const meta = TYPE_META[item.type] || {};
  const { Icon } = meta;
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState('');
  const needsReason = item.type === 'pto';

  const doReject = () => {
    if (needsReason && !rejecting) { setRejecting(true); return; }
    if (needsReason && !reason.trim()) return;
    onReject(item, reason.trim());
  };

  return (
    <div
      className={`shoot-notif-item${item.unread ? ' unread' : ''}`}
      role="button"
      tabIndex={0}
      onClick={() => onOpen && onOpen(item)}
      onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && onOpen) onOpen(item); }}
    >
      <div
        className="shoot-notif-av"
        style={item.actorPhoto ? { backgroundImage: `url(${item.actorPhoto})` } : undefined}
      >
        {!item.actorPhoto && initialsOf(item.actorName)}
        {Icon ? (
          <span className="shoot-notif-av-badge" style={{ background: meta.color }}>
            <Icon size={10} strokeWidth={2.4} />
          </span>
        ) : null}
      </div>

      <div className="shoot-notif-body">
        <Message item={item} />
        <Detail item={item} />

        {item.status === 'pending' && item.actionable && (
          <>
            {rejecting ? (
              <textarea
                className="shoot-notif-reason"
                autoFocus
                value={reason}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Add a reason for denial (required)"
              />
            ) : null}
            <div className="shoot-notif-actions" onClick={(e) => e.stopPropagation()}>
              <button type="button" className="shoot-notif-approve" disabled={busy} onClick={() => onApprove(item)}>
                <Check size={14} strokeWidth={2.6} />
                Approve
              </button>
              <button
                type="button"
                className="shoot-notif-reject"
                disabled={busy || (rejecting && needsReason && !reason.trim())}
                onClick={doReject}
              >
                <X size={14} strokeWidth={2.6} />
                {rejecting ? 'Confirm deny' : 'Reject'}
              </button>
              {rejecting ? (
                <button
                  type="button"
                  className="shoot-notif-textbtn"
                  onClick={() => { setRejecting(false); setReason(''); }}
                >
                  Cancel
                </button>
              ) : null}
            </div>
          </>
        )}
        {item.status === 'pending' && !item.actionable && (
          <div className="shoot-notif-status pending">
            <Hourglass size={13} strokeWidth={2.4} />
            {' '}
            Pending review
          </div>
        )}
        {(item.status === 'approved' || item.status === 'rejected') && (
          <div className={`shoot-notif-status ${item.status}`}>
            {item.status === 'approved'
              ? <><Check size={14} strokeWidth={2.6} /> Approved</>
              : <><X size={14} strokeWidth={2.6} /> Rejected</>}
          </div>
        )}
        <div className="shoot-notif-time">{item.time}</div>
      </div>

      {item.unread ? <span className="shoot-notif-dot" /> : null}
    </div>
  );
}
